export function getValue(value) {
  return value.toLocaleString("pt-br", { style: "currency", currency: "BRL" });
}

export function getDate(date) {
  let fortmatDate = date.split("/");
  return new Date(fortmatDate[2], fortmatDate[1] - 1, fortmatDate[0]);
}

export function phoneFormat(phone) {
  phone = phone.replace(/[^\d]/g, "");
  if (phone.length >= 11) {
    return phone.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  }
  if (phone.length >= 10) {
    return phone.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  }
  return phone;
}
export function generatePix(valor, txid) {
  const chave = "46316746000100"; // Chave Pix do tipo CNPJ (fixa)
  const nome = "GURUSEGLTDA"; // Nome da empresa (fixo)
  const cidade = "MT"; // Cidade (fixa)

  function format(id, value) {
    const length = String(value.length).padStart(2, "0");
    return `${id}${length}${value}`;
  }
  function crc16CCITT(str) {
    let crc = 0xffff;
    for (let i = 0; i < str.length; i++) {
      crc ^= str.charCodeAt(i) << 8;
      for (let j = 0; j < 8; j++) {
        crc = (crc & 0x8000) !== 0 ? (crc << 1) ^ 0x1021 : crc << 1;
      }
      crc &= 0xffff;
    }
    return crc.toString(16).padStart(4, "0");
  }

  const payloadFormat = "000201";
  const merchantAccount = format(
    "26",
    format("00", "BR.GOV.BCB.PIX") + format("01", chave)
  );
  const merchantCategoryCode = "52040000";
  const transactionCurrency = "5303986";
  const transactionAmount = valor ? format("54", Number(valor).toFixed(2)) : "";
  const countryCode = "5802BR";
  const merchantName = format("59", nome.substring(0, 25));
  const merchantCity = format("60", cidade.substring(0, 15));
  const txidField = format("62", format("05", txid));

  const fullPayload =
    payloadFormat +
    merchantAccount +
    merchantCategoryCode +
    transactionCurrency +
    transactionAmount +
    countryCode +
    merchantName +
    merchantCity +
    txidField;

  const crc16 = crc16CCITT(fullPayload + "6304");
  console.log(fullPayload + "6304" + crc16.toUpperCase());
  return fullPayload + "6304" + crc16.toUpperCase();
}

export function formatarDuracaoCompleta(duracao) {
  const partes = [];
  if (duracao.years)
    partes.push(`${duracao.years} ${duracao.years === 1 ? "ano" : "anos"}`);
  if (duracao.months)
    partes.push(`${duracao.months} ${duracao.months === 1 ? "mês" : "meses"}`);
  if (duracao.days)
    partes.push(`${duracao.days} ${duracao.days === 1 ? "dia" : "dias"}`);
  if (duracao.hours)
    partes.push(`${duracao.hours} ${duracao.hours === 1 ? "hora" : "horas"}`);
  if (duracao.minutes)
    partes.push(
      `${duracao.minutes} ${duracao.minutes === 1 ? "minuto" : "minutos"}`
    );
  if (duracao.seconds)
    partes.push(
      `${duracao.seconds} ${duracao.seconds === 1 ? "segundo" : "segundos"}`
    );

  if (partes.length === 0) return "0 segundos";
  if (partes.length === 1) return partes[0];

  const ultima = partes.pop();
  return partes.join(", ") + " e " + ultima;
}
